var map = {
	"./authentication/auth.module": [
		"./src/app/authentication/auth.module.ts",
		"default~authentication-auth-module~component-component-module",
		"authentication-auth-module"
	],
	"./component/component.module": [
		"./src/app/component/component.module.ts",
		"default~component-component-module~starter-starter-module",
		"default~authentication-auth-module~component-component-module",
		"component-component-module"
	],
	"./starter/starter.module": [
		"./src/app/starter/starter.module.ts",
		"default~component-component-module~starter-starter-module",
		"starter-starter-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;